import { Component } from 'react';
import { RadioButton } from 'primereact/radiobutton';
import { CancelRed, CrossInBox, GreenCheck, EyeIconClasset } from '../../svgIcons';
import LoadingComponent from '../../loadingComponent';
import Service from '../../services';
import { baseUrlAdmin } from '../../../store/apiConstants';
import { Toast } from 'primereact/toast';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Button } from 'primereact/button';
import { BasicLazyParams } from '../../../utile';
import { debounce } from 'lodash';
import { Dialog } from 'primereact/dialog';
import '../styles.scss';
import ClassetTextArea from '../../../classetComponents/classetTextArea';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { InputText } from 'primereact/inputtext';
import BranchToSectionApprovalHierarchy from '../../BaseDropdownComponents/BranchToSectionApprovalHierarchy';
import { Tag } from 'primereact/tag';

export default class AssignTransport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchLevel: 1,
            lazyParams: BasicLazyParams,
            studentInfo: [],
            selectedRows: [],
            selectAll: false,
            filteredUsers: [],
            filters: {
                'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
                'name': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
                'firstName': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
                'lastName': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
                'studentsInfo.0.user_info.enrollmentId': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
                'contactPersonName': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
                'parentContactNo': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
                'totalFee': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
                'refundRaisedAmt': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] }
            },
            globalFilterValue: '',
        };
        this.debouncedApiCall = debounce(this.getStudentsInfo, 500);
        this.service = new Service();
    }
    setDropdownValues = (dropdownsData) => {
        this.setState(
            {
                dropdownsData,
                studentId: null,
                filteredUsers: [],
                totalRecords: 0,
                studentInfo: [],
            },
            () => {
                this.getStudentsInfo();
            }
        );
    };
    handleSetSearchValue = (value) => {
        this.setState(
            {
                searchValue: value,
                dropdownsData: {
                    boardId: '',
                    branchId: '',
                    classId: '',
                    sectionId: ''
                }
            },
            () => {
                this.debouncedApiCall();
            }
        );
    };

    handleSearchLevel = (value) => {
        this.setState({ searchLevel: value, studentId: '', searchValue: '', studentsData: [] });
    };
    onHandleAssignTransportApprove = async (selectedStudentInfo, isConfirmed) => {
        // isConfirmed && await this.getFeeStructures(rowData?.existingFeeInfo?.feeStructure ? true : false)
        this.setState({
            isApproved: isConfirmed ? true : false,
            isRejected: !isConfirmed ? true : false,
            selectedStudent: selectedStudentInfo,
        }, () => this.state.isApproved && this.onApproveAssignTransport(true));
    };

    openViewDialog = (rowData) => {
        this.setState({ isViewDialogOpen: true, viewRowData: rowData });
    };

    closeViewDialog = () => {
        this.setState({ isViewDialogOpen: false, viewRowData: null });
    };

    getFeeStructures = (isTransportExists) => {
        this.setState({
            isLoading: true
        });
        const academicYear = localStorage.getItem('userAcademicYear');
        let url = `${baseUrlAdmin}/fee-structure/transportfees?academicYear=${academicYear}&isNew=${false}`;
        const currentDate = new Date();
        this.service.get(url, true).then(res => {
            if (res && res.status && res.res.status) {
                if (res.res.data && res.res?.data?.length) {
                    this.setState({
                        isLoading: false,
                        feeStructure: isTransportExists ? res?.res?.data : res?.res?.data?.filter(item => {
                            if (item.stepTwo && Array.isArray(item.stepTwo)) {
                                return !item.stepTwo.some(step => new Date(step.dueDate) < currentDate);
                            }
                            return true;
                        })
                    });

                } else {
                    this.setState({
                        isLoading: false
                    });
                    this.toast.show({ severity: 'error', summary: 'No Transport Fee Structures Found.', detail: res.errMessage, life: 3000 });
                }
            } else {
                this.setState({
                    isLoading: false
                });
                this.toast.show({ severity: 'error', summary: 'Some error occurred', detail: res.errMessage, life: 3000 });
            }
        }).catch(e => {
            this.setState({
                isLoading: false
            });
            this.toast.show({ severity: 'error', summary: 'Error', detail: e.toString(), life: 3000 });
            console.log(e);
        })
    }
    getStudentsInfo = () => {
        let { lazyParams, globalSearch } = this.state;
        this.setState({ isLoading: true, studentInfo: [] });
        const url = `${baseUrlAdmin}/transport-assign-approval/get-pending-approvals?limit=${lazyParams.rows}&page=${lazyParams.page + 1}&search=${globalSearch}`;

        let academicYear = localStorage.getItem('userAcademicYear');
        let username = this.state.searchType === 'studentName' ? this.state?.searchValue : '';
        let enrollmentNo = this.state.searchType === 'enrollmentNumber' ? this.state?.searchValue : '';

        let payload = {
            branchId: this.state?.dropdownsData?.branchIds,
            boardId: this.state?.dropdownsData?.boardIds,
            gradeId: this.state?.dropdownsData?.classIds,
            sectionId: this.state?.dropdownsData?.sectionId,
            academicYear: academicYear,
            assignedHeirarchy: this.state.dropdownsData.heirarchy
        };

        this.service
            .post(url, payload, true)
            .then((res) => {
                if (res && res.status && res.res.status) {
                    if (res.res?.records && res.res?.records?.length) {
                        this.setState({
                            isLoading: false,
                            studentInfo: res.res.records,
                            filteredUsers: res.res.records,
                            totalRecords: res.res.totalRecords
                        });
                    } else if (res.res?.records?.length == 0) {
                        this.setState({
                            isLoading: false
                        });
                        this.toast.show({ severity: 'success', summary: 'No records found.', detail: '', life: 3000 });
                    } else {
                        this.setState({
                            isLoading: false
                        });
                        this.toast.show({ severity: 'error', summary: 'Some error occurred', detail: res.errMessage, life: 3000 });
                    }
                } else {
                    this.setState({
                        isLoading: false
                    });
                    this.toast.show({ severity: 'error', summary: 'Some error occurred', detail: res.errMessage, life: 3000 });
                }
            })
            .catch((e) => {
                this.setState({
                    isLoading: false
                });
                console.log(e);
            });
    };
    onStudentChange = (e) => {
        const name = this.state?.students
            ?.filter((each) => {
                return each.value === e.value;
            })
            .map((student) => student.label);
        this.setState({ studentId: e.value, studentName: name }, () => e.value && this.getStudentsInfo());
    };

    onApproveAssignTransport = (status) => {
        let students = Array.isArray(this.state.selectedStudent) ?
            this.state.selectedStudent : [this.state.selectedStudent];

        let payload = {
            selectedStudents: students.map(student => ({
                ...student,
                isApproved: status,
                remarks: this.state.remarks,
                handledBy: student?.handledBy || [],
                levelAndBranchDetails: this.state.dropdownsData?.heirarchy?.adminLevels?.filter((al) => al._id == student?.branchId)
            }))
        };

        this.setState({
            isLoading: true
        });
        let url = `${baseUrlAdmin}/transport-assign-approval/approve-assigned-transport`;
        this.service
            .post(url, payload, true)
            .then((res) => {
                if (res && res.status && res.res.status) {
                    this.setState(
                        {
                            isLoading: false,
                            isRejected: false,
                            isApproved: false,
                            selectedStopInfo: null,
                            filteredUsers: [],
                            remarks: '',
                            selectedFeeStructure: ""
                        },
                        () => this.getStudentsInfo()
                    );
                    this.toast.show({ severity: 'success', summary: 'Success', detail: res?.res?.message, life: 3000 });
                } else {
                    this.setState({
                        isLoading: false
                    });
                    const errMsg = res?.res?.message || res?.res?.errMessage || res?.errMessage || 'Failed to process approval';
                    this.toast.show({ severity: 'error', summary: 'Approval Failed', detail: errMsg, life: 6000 });
                }
            })
            .catch((e) => {
                this.setState({
                    isLoading: false
                });
                this.toast.show({ severity: 'error', summary: 'Error', detail: 'Some error occurred', life: 3000 });
            });
    };
    onSelectAllChange = (event) => {
        const { checked } = event;
        const selectedRows = checked ? [...this.state.filteredUsers] : [];
        this.setState({
            selectedRows,
            selectAll: checked
        });
    };
    onSelectionChange = (event) => {
        // Check if the selected row is already in selectedRows
        this.setState({
            selectedRows: event.value
        });
    };

    renderHeader() {
        return (
            <div className="flex justify-content-between align-items-center">
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText value={this.state.globalFilterValue} onChange={this.onGlobalFilterChange} placeholder="Name/Enrollment Id" />
                </span>
                {/* <h5 className="m-0">Customers</h5> */}
            </div>
        )
    }
    onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let filters = { ...this.state.filters };
        filters['global'].value = value;
        this.setState({ filters, globalFilterValue: value });
    };
    render() {

        const header = this.renderHeader();
        return (
            <div className="ma-main">
                <div className=" datatable-crud-demo mx-2">
                    <div className="flex">
                        <div className="flex flex-column justify-content-center align-items-center mt-3">
                            <RadioButton
                                inputId="ingredient1"
                                onChange={(e) => this.handleSearchLevel(1)}
                                checked={this.state.searchLevel === 1}
                            />
                        </div>
                        <BranchToSectionApprovalHierarchy selectedValue={this.state.searchLevel} setValues={this.setDropdownValues} approvalType={'assignTransport'} />
                    </div>

                    {/* <div className="flex mt-4">
                        <div className="flex flex-column justify-content-center align-items-center mt-3">
                            <RadioButton
                                inputId="ingredient2"
                                onChange={(e) => this.handleSearchLevel(2)}
                                checked={this.state.searchLevel === 2}
                            />
                        </div>

                        <div className="field ml-4">
                            <ClassetStudentSearchFilter
                                ref={this.studentSearchRef}
                                selectedValue={this.state.searchLevel}
                                setValues={this.setDropdownValues}
                            />
                        </div>
                    </div> */}
                </div>

                <DataTable
                    value={this.state.filteredUsers}
                    dataKey="_id"
                    paginator
                    lazy={false}
                    responsiveLayout="scroll"
                    className="dataTableValuesText"
                    showGridlines
                    selectionMode={'checkbox'}
                    columnResizeMode="expand"
                    resizableColumns
                    onPage={this.onPage}
                    first={this.state.lazyParams.first}
                    last={this.state.studentstotalRecords}
                    rows={this.state.lazyParams.rows}
                    totalRecords={this.state.studentstotalRecords}
                    rowsPerPageOptions={[5, 10, 25, 50, 100]}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                    globalFilter={this.state.globalFilter}
                    onSelectionChange={this.onSelectionChange}
                    selection={this.state.selectedRows}
                    header={header}
                    filters={this.state.filters}
                    filterDisplay="menu"
                    loading={this.state.isLoading}
                    tableStyle={{ tableLayout: 'auto' }}
                    globalFilterFields={[
                        'studentsInfo.0.user_info.firstName',
                        'studentsInfo.0.user_info.lastName',
                        'studentsInfo.0.user_info.enrollmentId'
                    ]}
                >
                    <Column
                        selectionMode="multiple"
                        style={{ width: '50px', maxWidth: '50px' }}
                        headerStyle={{ width: '50px', textAlign: 'center' }}
                        bodyStyle={{ textAlign: 'center' }}
                    />
                    <Column
                        sortable
                        field="studentsInfo.0.user_info.enrollmentId"
                        filterField="studentsInfo.0.user_info.enrollmentId"
                        header="Enrollment Id"
                        style={{
                            minWidth: '130px',
                            textAlign: 'left'
                        }}
                        headerStyle={{
                            backgroundColor: '#f8f9fa',
                            padding: '1rem',
                            fontWeight: '600',
                            textAlign: 'left'
                        }}
                        body={(rowData) => {
                            return (
                                <div>{rowData?.studentsInfo[0]?.user_info?.enrollmentId}</div>
                            );
                        }}
                    />
                    <Column
                        sortable
                        field="studentsInfo.0.user_info.firstName"
                        filterField="studentsInfo.0.user_info.firstName"
                        className="datatable-cell"
                        header="Student Name"
                        style={{
                            minWidth: '150px',
                            textAlign: 'left'
                        }}
                        headerStyle={{
                            backgroundColor: '#f8f9fa',
                            padding: '1rem',
                            fontWeight: '600',
                            textAlign: 'left'
                        }}
                        body={(rowData) => {
                            return (
                                <div>{rowData?.studentsInfo[0]?.user_info?.firstName} {rowData?.studentsInfo[0]?.user_info?.lastName}</div>
                            );
                        }}
                    />
                    <Column
                        filterField="pickUpLocation"
                        field="pickUpLocation"
                        sortable
                        className="datatable-cell"
                        header="Pick Up Location"
                        style={{
                            minWidth: '140px',
                            textAlign: 'left'
                        }}
                        headerStyle={{
                            backgroundColor: '#f8f9fa',
                            padding: '1rem',
                            fontWeight: '600',
                            textAlign: 'left'
                        }}
                        body={(rowData) => {
                            return <div>{rowData?.selectedPickUpStop?.stopName}</div>;
                        }}
                    />
                    <Column
                        filterField="dropLocation"
                        field="dropLocation"
                        sortable
                        className="datatable-cell"
                        header="Drop Location"
                        style={{
                            minWidth: '140px',
                            textAlign: 'left'
                        }}
                        headerStyle={{
                            backgroundColor: '#f8f9fa',
                            padding: '1rem',
                            fontWeight: '600',
                            textAlign: 'left'
                        }}
                        body={(rowData) => {
                            return <div>{rowData?.selectedDropStop?.stopName}</div>;
                        }}
                    />
                    <Column
                        filterField="serviceName"
                        field="serviceName"
                        sortable
                        style={{
                            minWidth: '180px',
                            textAlign: 'left'
                        }}
                        headerStyle={{
                            backgroundColor: '#f8f9fa',
                            padding: '1rem',
                            fontWeight: '600',
                            textAlign: 'left'
                        }}
                        className="datatable-cell"
                        header="Service"
                        bodyStyle={{ textAlign: 'start' }}
                        body={(rowData) => {
                            const serviceInfo = rowData?.serviceInfo;
                            const serviceName = serviceInfo?.serviceName || '-';
                            const routeName = serviceInfo?.routeName;
                            const routeNo = serviceInfo?.routeNo;
                            const vehicleNo = serviceInfo?.vehicleRegistrationNo;
                            return (
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                    <span style={{ fontWeight: '600' }}>{serviceName}</span>
                                    {routeName && (
                                        <span style={{ fontSize: '12px', color: '#6c757d' }}>
                                            Route: {routeName}{routeNo ? ` (${routeNo})` : ''}
                                        </span>
                                    )}
                                    {vehicleNo && (
                                        <span style={{ fontSize: '11px', color: '#888' }}>
                                            Vehicle: {vehicleNo}
                                        </span>
                                    )}
                                </div>
                            );
                        }}
                    />
                    <Column
                        header="Request Type"
                        field="requestType"
                        style={{ minWidth: '120px', textAlign: 'center' }}
                        headerStyle={{ backgroundColor: '#f8f9fa', padding: '1rem', fontWeight: '600', textAlign: 'center' }}
                        alignHeader="center"
                        align="center"
                        body={(rowData) => {
                            const type = rowData?.requestType || 'ASSIGN';
                            const severity = type === 'CHANGE' ? 'warning' : type === 'REMOVE' ? 'danger' : 'info';
                            return <Tag value={type} severity={severity} />;
                        }}
                    />
                    <Column
                        header="Fee Adjustment"
                        style={{ minWidth: '200px', textAlign: 'left' }}
                        headerStyle={{ backgroundColor: '#f8f9fa', padding: '1rem', fontWeight: '600', textAlign: 'left' }}
                        body={(rowData) => {
                            const type = rowData?.requestType || 'ASSIGN';
                            if (type !== 'CHANGE') return <span style={{ color: '#9ca3af', fontSize: '12px' }}>—</span>;

                            const proRataInfo = rowData?.proRataInfo;
                            const effectiveDateStr = (proRataInfo?.effectiveDate || rowData?.effectiveDate)
                                ? new Date(proRataInfo?.effectiveDate || rowData?.effectiveDate).toLocaleDateString('en-IN')
                                : '-';

                            if (!proRataInfo?.isProRataApplied) {
                                return (
                                    <div style={{ fontSize: '12px', lineHeight: '1.6' }}>
                                        <div><span style={{ color: '#6b7280' }}>Effective:</span> {effectiveDateStr}</div>
                                        <div style={{ color: '#6b7280', fontStyle: 'italic' }}>Auto-calculated at approval</div>
                                    </div>
                                );
                            }

                            return (
                                <div style={{ fontSize: '12px', lineHeight: '1.6' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '2px' }}>
                                        <Tag value={proRataInfo.mode || 'AUTO'} severity={proRataInfo.mode === 'MANUAL' ? 'warning' : 'success'} style={{ fontSize: '10px' }} />
                                    </div>
                                    <div><span style={{ color: '#6b7280' }}>Effective:</span> {effectiveDateStr}</div>
                                    <div><span style={{ color: '#6b7280' }}>Days used / left:</span> {proRataInfo.daysConsumed} / {proRataInfo.daysRemaining}</div>
                                    <div style={{ color: '#dc2626', fontWeight: '600' }}>
                                        Old route (closing): ₹{(proRataInfo.closingAmount || 0).toLocaleString('en-IN')}
                                    </div>
                                    <div style={{ color: '#16a34a', fontWeight: '600' }}>
                                        New route (remaining): ₹{(proRataInfo.newFeeAmount || 0).toLocaleString('en-IN')}
                                    </div>
                                </div>
                            );
                        }}
                    />
                    <Column
                        header="View"
                        style={{ width: '70px', textAlign: 'center' }}
                        headerStyle={{ backgroundColor: '#f8f9fa', padding: '1rem', fontWeight: '600', textAlign: 'center' }}
                        alignHeader="center"
                        align="center"
                        body={(rowData) => (
                            <div className="flex justify-content-center cursor-pointer" onClick={() => this.openViewDialog(rowData)}>
                                <EyeIconClasset />
                            </div>
                        )}
                    />
                    <Column
                        header="Approve/Reject"
                        style={{
                            width: '130px',
                            textAlign: 'center'
                        }}
                        headerStyle={{
                            backgroundColor: '#f8f9fa',
                            padding: '1rem',
                            fontWeight: '600',
                            textAlign: 'center'
                        }}
                        alignHeader="center"
                        align="center"
                        body={(rowData) => {
                            if (rowData?.isRefundApproved !== undefined) {
                                return null;
                            }
                            return (
                                <div className="flex justify-content-center align-items-center gap-2">
                                    <div className="cursor-pointer" onClick={() => this.onHandleAssignTransportApprove(rowData, true)}>
                                        <GreenCheck />
                                    </div>
                                    <div className="cursor-pointer" onClick={() => this.onHandleAssignTransportApprove(rowData, false)}>
                                        <CancelRed />
                                    </div>
                                </div>
                            );
                        }}
                    />
                </DataTable>

                <div className="flex justify-content-end my-2 mr-2">
                    <Button
                        className="px-4 py-2"
                        style={{
                            backgroundColor: '#7CDD56',
                            border: 'none',
                            borderRadius: '8px',
                            color: 'white',
                            height: '48px',
                            fontSize: '16px',
                        }}
                        disabled={this.state.selectedRows.length === 0}
                        onClick={() => {
                            if (this.state.selectedRows.length > 0) {
                                this.onHandleAssignTransportApprove(this.state.selectedRows, true);
                            } else {
                                this.toast.show({
                                    severity: 'warn',
                                    summary: 'Warning',
                                    detail: 'Please select a record to approve',
                                    life: 3000
                                });
                            }
                        }}
                    >
                        Approve Selected Requests
                    </Button>
                </div>

                <Dialog
                    visible={this.state.isRejected}
                    draggable={false}
                    closeOnEscape={false}
                    style={{ width: 400 }}
                    dismissableMask={false}
                    closable={false}
                    header={() => {
                        const serviceInfo = this.state.selectedStudent?.serviceInfo;
                        return (
                            <div className="mt-2 formHeadingInter">
                                <div className="mb-3">
                                    <CrossInBox bgcolor={'#BF0031'} color={'white'} />
                                </div>
                                {serviceInfo?.serviceName && (
                                    <p style={{ fontWeight: 'bold', fontSize: 14 }}>Service : {serviceInfo?.serviceName}</p>
                                )}
                                {serviceInfo?.routeName && (
                                    <p style={{ fontWeight: '500', fontSize: 14 }}>Route : {serviceInfo?.routeName}</p>
                                )}
                                {serviceInfo?.vehicleRegistrationNo && (
                                    <p style={{ fontWeight: '500', fontSize: 14 }}>Vehicle No : {serviceInfo?.vehicleRegistrationNo}</p>
                                )}
                                <p style={{ fontWeight: '400', fontSize: 14 }}>Pickup Location : {this.state.selectedStudent?.selectedPickUpStop?.stopName}</p>
                                <p style={{ fontWeight: '400', fontSize: 14 }}>Drop Location : {this.state.selectedStudent?.selectedDropStop?.stopName}</p>
                            </div>
                        );
                    }}
                    footer={() => (
                        <div className="flex justify-content-center mb-4">
                            <Button
                                className="formSubmitButton px-4"
                                style={{ borderRadius: '10px', backgroundColor: '#BF0031', border: 'none' }}
                                onClick={() => {
                                    this.onApproveAssignTransport(false);
                                }}
                            >
                                <p className="formSubmitButtonText">Reject</p>
                            </Button>
                            <Button className="formCancelButton px-4" style={{ backgroundColor: '#F4F5F6', border: 0 }} onClick={() => this.setState({ isRejected: false, selectedFeeType: {} })}>
                                <p className="formCancelButtonText">Cancel</p>
                            </Button>
                        </div>
                    )}
                    onHide={() => this.setState({ isRejected: false, selectedFeeType: {} })}
                >
                    <div className=" m-3 pt-3" style={{ alignItems: 'center', justifyContent: 'center' }}>
                        <div className="">
                            <ClassetTextArea width={'100%'} style={{ height: '119px' }} label={'Remarks:'} placeholder="Remarks" value={this.state.remarks} onChange={(e) => this.setState({ remarks: e.target.value })} />
                        </div>
                    </div>
                </Dialog>
                {/* Read-only View Dialog — shows the same installment fee panel as the raising popup */}
                <Dialog
                    visible={this.state.isViewDialogOpen}
                    draggable={false}
                    closable={true}
                    dismissableMask={true}
                    style={{ width: '700px' }}
                    header={
                        <div className="flex align-items-center gap-2">
                            <EyeIconClasset />
                            <span style={{ fontFamily: 'InterSemiBold', fontSize: '16px', marginLeft: '8px' }}>Transport Assignment Details</span>
                        </div>
                    }
                    onHide={this.closeViewDialog}
                >
                    {(() => {
                        const row = this.state.viewRowData;
                        if (!row) return null;
                        const student = row.studentsInfo?.[0]?.user_info;
                        const serviceInfo = row.serviceInfo;
                        const installments = row.installmentNewAmounts || [];
                        const isChange = row.requestType === 'CHANGE';
                        const noFeeChange = row.noFeeChange === true;

                        return (
                            <div className="p-3">
                                {/* Student & Service Info */}
                                <div className="grid mb-3">
                                    <div className="col-6">
                                        <p className="m-0" style={{ fontSize: '13px', color: '#6b7280' }}>Student</p>
                                        <p className="m-0" style={{ fontFamily: 'InterSemiBold', fontSize: '14px' }}>{student?.firstName} {student?.lastName}</p>
                                        <p className="m-0" style={{ fontSize: '12px', color: '#6b7280' }}>{student?.enrollmentId}</p>
                                    </div>
                                    <div className="col-6">
                                        <p className="m-0" style={{ fontSize: '13px', color: '#6b7280' }}>Service</p>
                                        <p className="m-0" style={{ fontFamily: 'InterSemiBold', fontSize: '14px' }}>{serviceInfo?.serviceName || '-'}</p>
                                        <p className="m-0" style={{ fontSize: '12px', color: '#6b7280' }}>
                                            {serviceInfo?.routeName} {serviceInfo?.routeNo ? `(${serviceInfo?.routeNo})` : ''}
                                        </p>
                                    </div>
                                    <div className="col-6">
                                        <p className="m-0" style={{ fontSize: '13px', color: '#6b7280' }}>Pickup Stop</p>
                                        <p className="m-0" style={{ fontFamily: 'InterSemiBold', fontSize: '14px' }}>{row.selectedPickUpStop?.stopName || '-'}</p>
                                    </div>
                                    <div className="col-6">
                                        <p className="m-0" style={{ fontSize: '13px', color: '#6b7280' }}>Drop Stop</p>
                                        <p className="m-0" style={{ fontFamily: 'InterSemiBold', fontSize: '14px' }}>{row.selectedDropStop?.stopName || '-'}</p>
                                    </div>
                                </div>

                                {isChange && noFeeChange && (
                                    <div className="p-2 border-round mb-3" style={{ backgroundColor: '#FFF7ED', border: '1px solid #FED7AA' }}>
                                        <span style={{ fontFamily: 'InterSemiBold', fontSize: '13px', color: '#92400E' }}>No Fee Change — Route updated without fee recalculation</span>
                                    </div>
                                )}

                                {/* Fee Installments Table — read-only */}
                                {isChange && !noFeeChange && installments.length > 0 && (
                                    <>
                                        <p className="font-semibold mb-2" style={{ fontSize: '14px', fontFamily: 'InterSemiBold' }}>
                                            <i className="pi pi-list mr-2"></i>Transport Fee Installments
                                        </p>
                                        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                                            <thead>
                                                <tr style={{ backgroundColor: '#F3F4F6' }}>
                                                    <th style={{ textAlign: 'left', padding: '8px 10px', border: '1px solid #E5E7EB', fontFamily: 'InterSemiBold' }}>Term Name</th>
                                                    <th style={{ textAlign: 'right', padding: '8px 10px', border: '1px solid #E5E7EB', fontFamily: 'InterSemiBold' }}>Term Amount (₹)</th>
                                                    <th style={{ textAlign: 'right', padding: '8px 10px', border: '1px solid #E5E7EB', fontFamily: 'InterSemiBold' }}>Paid (₹)</th>
                                                    <th style={{ textAlign: 'right', padding: '8px 10px', border: '1px solid #E5E7EB', fontFamily: 'InterSemiBold' }}>Due (₹)</th>
                                                    <th style={{ textAlign: 'right', padding: '8px 10px', border: '1px solid #E5E7EB', fontFamily: 'InterSemiBold' }}>New Entry Amount (₹)</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {installments.map((inst, idx) => (
                                                    <tr key={inst.installmentId || idx} style={{ backgroundColor: idx % 2 === 0 ? '#fff' : '#F9FAFB' }}>
                                                        <td style={{ padding: '8px 10px', border: '1px solid #E5E7EB', fontFamily: 'InterRegular' }}>{inst.termName}</td>
                                                        <td style={{ padding: '8px 10px', border: '1px solid #E5E7EB', textAlign: 'right', fontFamily: 'InterRegular' }}>
                                                            {(inst.termAmount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                        </td>
                                                        <td style={{ padding: '8px 10px', border: '1px solid #E5E7EB', textAlign: 'right', color: '#16A34A', fontFamily: 'InterRegular' }}>
                                                            {(inst.paidAmount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                        </td>
                                                        <td style={{ padding: '8px 10px', border: '1px solid #E5E7EB', textAlign: 'right', color: (inst.dueAmount || 0) > 0 ? '#DC2626' : '#16A34A', fontFamily: 'InterRegular' }}>
                                                            {(inst.dueAmount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                        </td>
                                                        <td style={{ padding: '8px 10px', border: '1px solid #E5E7EB', textAlign: 'right', fontFamily: 'InterSemiBold', color: '#1D4ED8' }}>
                                                            {(inst.newAmount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>

                                        {/* Fee Summary */}
                                        <div className="mt-3 p-3 border-round" style={{ backgroundColor: '#EFF6FF', border: '1px solid #BFDBFE' }}>
                                            <p className="m-0 mb-2" style={{ fontFamily: 'InterSemiBold', fontSize: '13px', color: '#1E40AF' }}>Fee Summary</p>
                                            <div className="flex justify-content-between" style={{ fontSize: '13px' }}>
                                                <span style={{ fontFamily: 'InterRegular' }}>Old Total Amount:</span>
                                                <span style={{ fontFamily: 'InterSemiBold', color: '#374151' }}>
                                                    ₹{installments.reduce((s, i) => s + (i.termAmount || 0), 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                </span>
                                            </div>
                                            <div className="flex justify-content-between mt-1" style={{ fontSize: '13px' }}>
                                                <span style={{ fontFamily: 'InterRegular' }}>New Total Amount:</span>
                                                <span style={{ fontFamily: 'InterSemiBold', color: '#1D4ED8' }}>
                                                    ₹{installments.reduce((s, i) => s + (i.newAmount || 0), 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                </span>
                                            </div>
                                        </div>
                                    </>
                                )}

                                {isChange && !noFeeChange && installments.length === 0 && (
                                    <div style={{ color: '#6b7280', fontSize: '13px' }}>Fee adjustment will be calculated automatically at approval time.</div>
                                )}
                            </div>
                        );
                    })()}
                </Dialog>

                <Toast ref={(el) => (this.toast = el)} position="bottom-right" />
                {this.state.isLoading && <LoadingComponent />}
            </div>
        );
    }
}
